import React from "react";

import { WSText } from "../core/WSText/WSText.component";
import { WSControl, WSControlProps } from "../WSControl/WSControl";
import { WSElement, WSElementProps } from "../WSElement/WSElement.component";
import { WSList } from "../WSList/WSList.component";

import { FilterField } from "./FilterField";
import { WSFilterOption, WSFilterType } from "./types";
import styles from "./WSFilters.module.scss";

export const OptionItem: React.FC<
  Omit<WSElementProps, "onChange"> &
    WSFilterOption & {
      type: WSFilterType;
      onChange: (value: WSControlProps["value"]) => void;
      value: WSControlProps["value"];
    }
> = ({
  name,
  type,
  value,
  helperText,
  label,
  options,
  onChange,
  disabled,
  subFilters,
  ...otherProps
}) => {
  let mainInput = null;

  switch (type) {
    case "radio":
    case "checkbox":
      mainInput = (
        <WSControl
          size="S"
          type={type === "checkbox" ? "multistep-checkbox" : type}
          name={name}
          label={label}
          value={value as any}
          onChange={onChange}
          disabled={disabled}
        />
      );
      break;
    default:
      return null;
  }

  return (
    <WSElement {...otherProps} className={styles.optionItem}>
      {mainInput}
      {helperText ? (
        <WSText.ParagraphXs
          className={styles[`optionHelpText-${type}`]}
          color={disabled ? "gray300" : "gray400"}
        >
          {helperText}
        </WSText.ParagraphXs>
      ) : null}
      {!!value && subFilters && (
        <WSElement colorBackground="gray50" mt="XL" p="XL">
          <WSList gap="XL">
            {subFilters.map((subFilter) => (
              <FilterField key={subFilter.name} {...subFilter} />
            ))}
          </WSList>
        </WSElement>
      )}
    </WSElement>
  );
};
